// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-2ePZS";
var _3 = "sub-1v09q";
var _4 = "social-2FNxB";
var _5 = "email-2VruM";
var _6 = "button-1AeEp";
export { _1 as "__esModule", _2 as "title", _3 as "sub", _4 as "social", _5 as "email", _6 as "button" }
export default { "__esModule": _1, "title": _2, "sub": _3, "social": _4, "email": _5, "button": _6 }
